module.exports = __webpack_public_path__ + "static/JG2-e5f8b923d672926899ab43c0e3316c42.png";